var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MeerkatNotifications',{staticStyle:{"z-index":"9999"},attrs:{"notifications":_vm.meerkatNotifications,"position":"bottom-center"},on:{"close":_vm.removeNotification}})}
var staticRenderFns = []

export { render, staticRenderFns }